// gkc_hash_code : 01FJGW9AB4VKN1PM0CVCZY1PTE
/* eslint-disable no-console */
import * as React from "react";
import uniqBy from "lodash/uniqBy";
import {
  createProgram,
  updateProgram,
  createComment,
  deleteProgram,
} from "../graphql/mutations";
import {
  getProgram,
  listPrograms,
  commentByProgram,
  programByCustomer,
} from "../graphql/queries";
import {
  limitQuery,
  RecordStatus,
  RehearsalCartIn,
} from "../common-definitions/common-enum";
import {
  Product,
  Program,
  CreateProgramInput,
  UpdateProgramInput,
  DeleteProgramInput,
  ModelProgramFilterInput,
  Comment,
  CreateCommentInput,
  UpdateCommentInput,
  ModelCommentFilterInput,
  ModelProgramConditionInput,
} from "../API";

import { diff } from "../libs/diff";

export const CLEAR_RESULT = "CLEAR_RESULT";

export const FETCH_PROGRAM = "FETCH_PROGRAM";
export const FETCH_PROGRAM_SUCCESS = "FETCH_PROGRAM_SUCCESS";
export const FETCH_PROGRAM_FAILURE = "FETCH_PROGRAM_FAILURE";

export const UPDATE_PROGRAM = "UPDATE_PROGRAM";
export const UPDATE_PROGRAM_SUCCESS = "UPDATE_PROGRAM_SUCCESS";
export const UPDATE_PROGRAM_FAILURE = "UPDATE_PROGRAM_FAILURE";

export const CREATE_REACTION = "CREATE_REACTION";
export const CREATE_REACTION_SUCCESS = "CREATE_REACTION_SUCCESS";
export const CREATE_REACTION_FAILURE = "CREATE_REACTION_FAILURE";

export const FETCH_COMMENTS = "FETCH_COMMENTS";
export const FETCH_COMMENTS_SUCCESS = "FETCH_COMMENTS_SUCCESS";
export const FETCH_COMMENTS_FAILURE = "FETCH_COMMENTS_FAILURE";
export const CREATE_COMMENT = "CREATE_COMMENT";
export const CREATE_COMMENT_SUCCESS = "CREATE_COMMENT_SUCCESS";
export const CREATE_COMMENT_FAILURE = "CREATE_COMMENT_FAILURE";

export const CREATE_PROGRAM_PLAY_VIDEO = "CREATE_PROGRAM_PLAY_VIDEO";
export const CREATE_PROGRAM_PLAY_VIDEO_SUCCESS =
  "CREATE_PROGRAM_PLAY_VIDEO_SUCCESS";
export const CREATE_PROGRAM_PLAY_VIDEO_FAILURE =
  "CREATE_PROGRAM_PLAY_VIDEO_FAILURE";

export const ADD_COMMENT_REALTIME = "ADD_COMMENT_REALTIME";
export const UPDATE_COMMENT_REALTIME = "UPDATE_COMMENT_REALTIME";
export const ADD_PROGRAM_CARTIN_REALTIME = "ADD_PROGRAM_CARTIN_REALTIME";
export const DELETE_PROGRAM_CARTIN_REALTIME = "DELETE_PROGRAM_CARTIN_REALTIME";

export const FETCH_PROGRAM_PRODUCTS = "FETCH_PROGRAM_PRODUCTS";
export const FETCH_PROGRAM_PRODUCTS_SUCCESS = "FETCH_PROGRAM_PRODUCTS_SUCCESS";
export const FETCH_PROGRAM_PRODUCTS_FAILURE = "FETCH_PROGRAM_PRODUCTS_FAILURE";
export const UPDATE_PROGRAM_PRODUCT_REALTIME =
  "UPDATE_PROGRAM_PRODUCT_REALTIME";

export const UPDATE_PRODUCT_REALTIME = "UPDATE_PRODUCT_REALTIME";

export const CREATE_PROGRAM_CARTIN = "CREATE_PROGRAM_CARTIN";
export const CREATE_PROGRAM_CARTIN_SUCCESS = "CREATE_PROGRAM_CARTIN_SUCCESS";
export const CREATE_PROGRAM_CARTIN_FAILURE = "CREATE_PROGRAM_CARTIN_FAILURE";

export const FETCH_PROGRAM_CARTIN_BY_CUSTOMER =
  "FETCH_PROGRAM_CARTIN_BY_CUSTOMER";
export const FETCH_PROGRAM_CARTIN_BY_CUSTOMER_SUCCESS =
  "FETCH_PROGRAM_CARTIN_BY_CUSTOMER_SUCCESS";
export const FETCH_PROGRAM_CARTIN_BY_CUSTOMER_FAILURE =
  "FETCH_PROGRAM_CARTIN_BY_CUSTOMER_FAILURE";

export const UPDATE_PROGRAM_CARTIN = "UPDATE_PROGRAM_CARTIN";
export const UPDATE_PROGRAM_CARTIN_SUCCESS = "UPDATE_PROGRAM_CARTIN_SUCCESS";
export const UPDATE_PROGRAM_CARTIN_FAILURE = "UPDATE_PROGRAM_CARTIN_FAILURE";

export const DELETE_PROGRAM_CARTIN = "DELETE_PROGRAM_CARTIN";
export const DELETE_PROGRAM_CARTIN_SUCCESS = "DELETE_PROGRAM_CARTIN_SUCCESS";
export const DELETE_PROGRAM_CARTIN_FAILURE = "DELETE_PROGRAM_CARTIN_FAILURE";

export const GO_PRODUCT_DETAIL_EXTERNAL = "GO_PRODUCT_DETAIL_EXTERNAL";
export const GO_PRODUCT_DETAIL_EXTERNAL_SUCCESS =
  "GO_PRODUCT_DETAIL_EXTERNAL_SUCCESS";
export const GO_PRODUCT_DETAIL_EXTERNAL_FAILURE =
  "GO_PRODUCT_DETAIL_EXTERNAL_FAILURE";

export interface ProgramData extends Program {
  orderQuantity?: number;
}

export const FetchProgram = (id: string) => {
  return {
    type: FETCH_PROGRAM as typeof FETCH_PROGRAM,
    payload: {
      function: getProgram,
      params: {
        id,
        dataType: "program",
      },
    },
  };
};

export const UpdateProgramDetail = (
  input: UpdateProgramInput,
  condition?: ModelProgramConditionInput
) => {
  return {
    type: UPDATE_PROGRAM as typeof UPDATE_PROGRAM,
    payload: {
      function: updateProgram,
      params: {
        input,
        condition,
      },
    },
  };
};

export const FetchProgramProducts = (
  id?: string,
  limit?: number,
  filter?: ModelProgramFilterInput,
  nextToken?: string
) => {
  return {
    type: FETCH_PROGRAM_PRODUCTS as typeof FETCH_PROGRAM_PRODUCTS,
    payload: {
      function: listPrograms,
      params: {
        id,
        dataType: {
          beginsWith: "product#",
        },
        limit: limit || limitQuery,
        filter: filter || {
          isDeleted: {
            ne: RecordStatus.DELETED,
          },
          productStatusUpdateAt: {
            beginsWith: "1#",
          },
        },
        nextToken,
      },
    },
  };
};

export const CreateProgramCartIn = (input: CreateProgramInput) => {
  return {
    type: CREATE_PROGRAM_CARTIN as typeof CREATE_PROGRAM_CARTIN,
    payload: {
      function: createProgram,
      params: {
        input,
      },
    },
  };
};

export const FetchProgramCartInByCustomer = (
  customerId?: string,
  limit?: number,
  filter?: ModelProgramFilterInput,
  nextToken?: string
) => {
  return {
    type: FETCH_PROGRAM_CARTIN_BY_CUSTOMER as typeof FETCH_PROGRAM_CARTIN_BY_CUSTOMER,
    payload: {
      function: programByCustomer,
      params: {
        customerId,
        dataType: {
          beginsWith: "cartIn#",
        },
        limit: limit || limitQuery,
        filter: {
          isRehearsal: {
            ne: RehearsalCartIn.IS_REHEARSAL,
          },
          ...filter,
        },
        nextToken,
      },
    },
  };
};

export const UpdateProgramCartIn = (input: UpdateProgramInput) => {
  return {
    type: UPDATE_PROGRAM_CARTIN as typeof UPDATE_PROGRAM_CARTIN,
    payload: {
      function: updateProgram,
      params: {
        input,
      },
    },
  };
};

export const DeleteProgramCartIn = (input: DeleteProgramInput) => {
  return {
    type: DELETE_PROGRAM_CARTIN as typeof DELETE_PROGRAM_CARTIN,
    payload: {
      function: deleteProgram,
      params: {
        input,
      },
    },
  };
};

export const ClearResult = () => ({
  type: CLEAR_RESULT as typeof CLEAR_RESULT,
  payload: {},
});

export const CreateReaction = (input: CreateProgramInput) => {
  return {
    type: CREATE_REACTION as typeof CREATE_REACTION,
    payload: {
      function: createProgram,
      params: {
        input,
      },
    },
  };
};

export const FetchComments = (
  programId: string,
  filter?: ModelCommentFilterInput,
  limit?: number,
  nextToken?: string
) => {
  return {
    type: FETCH_COMMENTS as typeof FETCH_COMMENTS,
    payload: {
      function: commentByProgram,
      params: {
        programId,
        filter,
        limit: limit || limitQuery,
        nextToken,
      },
    },
  };
};

export const CreateComment = (input: CreateCommentInput) => {
  return {
    type: CREATE_COMMENT as typeof CREATE_COMMENT,
    payload: {
      function: createComment,
      params: {
        input,
      },
    },
  };
};

export const CreateProgramPlayVideo = (input: CreateProgramInput) => {
  return {
    type: CREATE_PROGRAM_PLAY_VIDEO as typeof CREATE_PROGRAM_PLAY_VIDEO,
    payload: {
      function: createProgram,
      params: {
        input,
      },
    },
  };
};

export const AddCommentRealtime = (data: UpdateCommentInput) => {
  return {
    type: ADD_COMMENT_REALTIME as typeof ADD_COMMENT_REALTIME,
    payload: {
      data,
    },
  };
};

export const AddProgramCartInRealtime = (data: Program) => {
  return {
    type: ADD_PROGRAM_CARTIN_REALTIME as typeof ADD_PROGRAM_CARTIN_REALTIME,
    payload: {
      data,
    },
  };
};

export const DeleteProgramCartInRealtime = (dataType: string) => {
  return {
    type: DELETE_PROGRAM_CARTIN_REALTIME as typeof DELETE_PROGRAM_CARTIN_REALTIME,
    payload: {
      dataType,
    },
  };
};

export const UpdateCommentRealtime = (data: UpdateCommentInput) => {
  return {
    type: UPDATE_COMMENT_REALTIME as typeof UPDATE_COMMENT_REALTIME,
    payload: {
      data,
    },
  };
};

export const UpdateProgramProductRealtime = (data: Program) => {
  return {
    type: UPDATE_PROGRAM_PRODUCT_REALTIME as typeof UPDATE_PROGRAM_PRODUCT_REALTIME,
    payload: {
      data,
    },
  };
};

export const UpdateProductRealtime = (data: Product) => {
  return {
    type: UPDATE_PRODUCT_REALTIME as typeof UPDATE_PRODUCT_REALTIME,
    payload: {
      data,
    },
  };
};

export const GoProductDetailExternal = (input: CreateProgramInput) => {
  return {
    type: GO_PRODUCT_DETAIL_EXTERNAL as typeof GO_PRODUCT_DETAIL_EXTERNAL,
    payload: {
      function: createProgram,
      params: {
        input,
      },
    },
  };
};

type FetchProgramSuccess = {
  type: typeof FETCH_PROGRAM_SUCCESS;
  payload: {
    data: {
      getProgram: Program;
    };
  };
};

type FetchProgramFailure = {
  type: typeof FETCH_PROGRAM_FAILURE;
  payload: {
    error: {
      message: string;
      status: number;
      code?: string;
    };
  };
};

type UpdateProgramSuccess = {
  type: typeof UPDATE_PROGRAM_SUCCESS;
  payload: {
    data: {
      updateProgram: Program;
    };
  };
};

type UpdateProgramFailure = {
  type: typeof UPDATE_PROGRAM_FAILURE;
  payload: {
    error: {
      message: string;
      status: number;
      code?: string;
    };
  };
};

type CreateReactionSuccess = {
  type: typeof CREATE_REACTION_SUCCESS;
  payload: {
    data: {
      createProgram: Program;
    };
  };
};

type FetchProgramProductsSuccess = {
  type: typeof FETCH_PROGRAM_PRODUCTS_SUCCESS;
  payload: {
    data: {
      listPrograms: {
        items: [];
        nextToken: string;
      };
    };
  };
};

type CreateReactionFailure = {
  type: typeof CREATE_REACTION_FAILURE;
  payload: {
    error: {
      message: string;
      status: number;
      code?: string;
    };
  };
};

type FetchCommentsSuccess = {
  type: typeof FETCH_COMMENTS_SUCCESS;
  payload: {
    data: {
      commentByProgram: {
        items: Comment[];
      };
    };
  };
};
type FetchProgramProductsFailure = {
  type: typeof FETCH_PROGRAM_PRODUCTS_FAILURE;
  payload: {
    error: {
      message: string;
      status: number;
      code?: string;
    };
  };
};

type CreateProgramCartInSuccess = {
  type: typeof CREATE_PROGRAM_CARTIN_SUCCESS;
  payload: {
    data: {
      createPrograms: {
        items: [];
        nextToken: string;
      };
    };
  };
};

type UpdateProgramCartInSuccess = {
  type: typeof UPDATE_PROGRAM_CARTIN_SUCCESS;
  payload: {
    data: {
      updatePrograms: {
        items: [];
        nextToken: string;
      };
    };
  };
};

type FetchProgramCartInByCustomerSuccess = {
  type: typeof FETCH_PROGRAM_CARTIN_BY_CUSTOMER_SUCCESS;
  payload: {
    data: {
      programByCustomer: {
        items: [];
        nextToken: string;
      };
    };
  };
};

type FetchProgramCartInByCustomerFailure = {
  type: typeof FETCH_PROGRAM_CARTIN_BY_CUSTOMER_FAILURE;
  payload: {
    error: {
      message: string;
      status: number;
      code?: string;
    };
  };
};

type FetchCommentsFailure = {
  type: typeof FETCH_COMMENTS_FAILURE;
  payload: {
    error: {
      message: string;
      status: number;
      code?: string;
    };
  };
};

type CreateProgramCartInFailure = {
  type: typeof CREATE_PROGRAM_CARTIN_FAILURE;
  payload: {
    error: {
      message: string;
      status: number;
      code?: string;
    };
  };
};

type UpdateProgramCartInFailure = {
  type: typeof UPDATE_PROGRAM_CARTIN_FAILURE;
  payload: {
    error: {
      message: string;
      status: number;
      code?: string;
    };
  };
};

type DeleteProgramCartInSuccess = {
  type: typeof DELETE_PROGRAM_CARTIN_SUCCESS;
  payload: {
    data: {
      deleteProgram: CreateProgramInput;
    };
  };
};

type CreateCommentSuccess = {
  type: typeof CREATE_COMMENT_SUCCESS;
  payload: {
    data: {
      createComment: UpdateCommentInput;
    };
  };
};

type CreateCommentFailure = {
  type: typeof CREATE_COMMENT_FAILURE;
  payload: {
    error: {
      message: string;
      status: number;
      code?: string;
    };
  };
};
type DeleteProgramCartIntFailure = {
  type: typeof DELETE_PROGRAM_CARTIN_FAILURE;
  payload: {
    error: {
      message: string;
      status: number;
      code?: string;
    };
  };
};

type CreateProgramPlayVideoSuccess = {
  type: typeof CREATE_PROGRAM_PLAY_VIDEO_SUCCESS;
  payload: {
    data: {
      createPrograms: {
        items: [];
        nextToken: string;
      };
    };
  };
};

type CreateProgramPlayVideoFailure = {
  type: typeof CREATE_PROGRAM_PLAY_VIDEO_FAILURE;
  payload: {
    error: {
      message: string;
      status: number;
      code?: string;
    };
  };
};

type GoProductDetailExternalSuccess = {
  type: typeof GO_PRODUCT_DETAIL_EXTERNAL_SUCCESS;
  payload: {
    data: {
      createPrograms: {
        items: [];
        nextToken: string;
      };
    };
  };
};

type GoProductDetailExternalFailure = {
  type: typeof GO_PRODUCT_DETAIL_EXTERNAL_FAILURE;
  payload: {
    error: {
      message: string;
      status: number;
      code?: string;
    };
  };
};

export type ProgramActions =
  | ReturnType<typeof ClearResult>
  | ReturnType<typeof FetchProgram>
  | ReturnType<typeof UpdateProgramDetail>
  | ReturnType<typeof CreateReaction>
  | ReturnType<typeof FetchComments>
  | ReturnType<typeof CreateComment>
  | ReturnType<typeof CreateProgramPlayVideo>
  | ReturnType<typeof AddCommentRealtime>
  | ReturnType<typeof UpdateCommentRealtime>
  | ReturnType<typeof FetchProgramProducts>
  | ReturnType<typeof UpdateProgramProductRealtime>
  | ReturnType<typeof UpdateProductRealtime>
  | ReturnType<typeof CreateProgramCartIn>
  | ReturnType<typeof UpdateProgramCartIn>
  | ReturnType<typeof DeleteProgramCartIn>
  | ReturnType<typeof GoProductDetailExternal>
  | ReturnType<typeof FetchProgramCartInByCustomer>
  | ReturnType<typeof AddProgramCartInRealtime>
  | ReturnType<typeof DeleteProgramCartInRealtime>
  | FetchProgramSuccess
  | FetchProgramFailure
  | UpdateProgramSuccess
  | UpdateProgramFailure
  | CreateReactionSuccess
  | CreateReactionFailure
  | FetchCommentsSuccess
  | FetchCommentsFailure
  | CreateCommentSuccess
  | CreateCommentFailure
  | FetchProgramProductsSuccess
  | FetchProgramProductsFailure
  | FetchProgramSuccess
  | FetchProgramFailure
  | CreateProgramCartInSuccess
  | CreateProgramCartInFailure
  | UpdateProgramCartInSuccess
  | UpdateProgramCartInFailure
  | DeleteProgramCartInSuccess
  | DeleteProgramCartIntFailure
  | CreateProgramPlayVideoSuccess
  | CreateProgramPlayVideoFailure
  | GoProductDetailExternalSuccess
  | GoProductDetailExternalFailure
  | FetchProgramCartInByCustomerSuccess
  | FetchProgramCartInByCustomerFailure;

export interface ProgramState {
  list: Program[];
  result: string;
  error?: { status?: number; message?: string; code?: string };
  program?: Program;
  programProducts?: Program[];
  comments?: UpdateCommentInput[];
  cartinProgramByCustomer?: Program[];
}

export const InitialProgramState: ProgramState = {
  list: [],
  result: "",
};

const reducer = (state: ProgramState, action: ProgramActions): ProgramState => {
  switch (action.type) {
    case FETCH_PROGRAM: {
      return {
        ...state,
        result: action.type,
      };
    }
    case FETCH_PROGRAM_SUCCESS: {
      return {
        ...state,
        result: action.type,
        program: action.payload.data?.getProgram,
      };
    }
    case FETCH_PROGRAM_FAILURE: {
      return {
        ...state,
        result: action.type,
        error: action.payload.error,
      };
    }
    case UPDATE_PROGRAM_SUCCESS: {
      return {
        ...state,
        result: action.type,
        program: action.payload.data?.updateProgram,
      };
    }
    case UPDATE_PROGRAM_FAILURE: {
      return {
        ...state,
        result: action.type,
        error: action.payload.error,
      };
    }
    case FETCH_COMMENTS_SUCCESS: {
      return {
        ...state,
        result: action.type,
        comments: action.payload.data?.commentByProgram.items,
      };
    }
    case FETCH_PROGRAM_PRODUCTS: {
      return {
        ...state,
        result: action.type,
      };
    }
    case FETCH_PROGRAM_PRODUCTS_SUCCESS: {
      return {
        ...state,
        result: action.type,
        programProducts: action.payload.data?.listPrograms?.items,
      };
    }
    case FETCH_PROGRAM_PRODUCTS_FAILURE: {
      return {
        ...state,
        result: action.type,
        error: action.payload.error,
      };
    }
    case UPDATE_PROGRAM_PRODUCT_REALTIME: {
      const programProducts = uniqBy(
        [action.payload.data, ...(state.programProducts || [])],
        "dataType"
      ).filter(
        (product: Program) =>
          product?.productStatusUpdateAt?.substring(0, 2) === "1#" &&
          product?.isDeleted !== 1
      );
      return {
        ...state,
        result: action.type,
        programProducts,
      };
    }
    case UPDATE_PRODUCT_REALTIME: {
      const programProducts = state.programProducts?.map((program: Program) => {
        if (program.productCode === action.payload.data.id) {
          return {
            ...program,
            product: action.payload.data,
          };
        }
        return program;
      });
      return {
        ...state,
        result: action.type,
        programProducts,
      };
    }
    case ADD_PROGRAM_CARTIN_REALTIME: {
      return {
        ...state,
        result: action.type,
        cartinProgramByCustomer: uniqBy(
          [...(state.cartinProgramByCustomer || []), action.payload.data],
          "dataType"
        ),
      };
    }
    case DELETE_PROGRAM_CARTIN_REALTIME: {
      return {
        ...state,
        result: action.type,
        cartinProgramByCustomer: [
          ...(state.cartinProgramByCustomer || []),
        ].filter(
          (cartIn: Program) => cartIn.dataType !== action.payload.dataType
        ),
      };
    }
    case CREATE_PROGRAM_CARTIN_SUCCESS: {
      return {
        ...state,
        result: action.type,
      };
    }
    case CREATE_PROGRAM_CARTIN_FAILURE: {
      return {
        ...state,
        result: action.type,
        error: action.payload.error,
      };
    }
    case DELETE_PROGRAM_CARTIN_SUCCESS: {
      return {
        ...state,
        result: action.type,
      };
    }
    case DELETE_PROGRAM_CARTIN_FAILURE: {
      return {
        ...state,
        result: action.type,
        error: action.payload.error,
      };
    }
    case CREATE_PROGRAM_PLAY_VIDEO_SUCCESS: {
      return {
        ...state,
        result: action.type,
      };
    }
    case CREATE_PROGRAM_PLAY_VIDEO_FAILURE: {
      return {
        ...state,
        result: action.type,
        error: action.payload.error,
      };
    }
    case FETCH_PROGRAM_CARTIN_BY_CUSTOMER_SUCCESS: {
      return {
        ...state,
        result: action.type,
        cartinProgramByCustomer: action.payload.data?.programByCustomer?.items,
      };
    }
    case FETCH_PROGRAM_CARTIN_BY_CUSTOMER_FAILURE: {
      return {
        ...state,
        result: action.type,
        error: action.payload.error,
      };
    }
    case ADD_COMMENT_REALTIME: {
      return {
        ...state,
        result: action.type,
        comments: uniqBy(
          [...(state.comments || []), action.payload.data],
          "id"
        ),
      };
    }
    case UPDATE_COMMENT_REALTIME: {
      return {
        ...state,
        result: action.type,
        comments: uniqBy(
          [action.payload.data, ...(state.comments || [])],
          "id"
        ),
      };
    }
    case CLEAR_RESULT:
      return {
        ...state,
        result: "",
        error: {},
      };
    default:
      return state;
  }
};

export const ProgramReducer =
  process.env.NODE_ENV === "production"
    ? reducer
    : (state: ProgramState, action: ProgramActions) => {
        console.groupCollapsed(action.type);
        console.log("action", action);
        const result = reducer(state, action);
        console.log("diff", diff(state, result));
        console.log("prevState", state);
        console.log("currentState", result);
        console.groupEnd();
        return result;
      };

type ContextState = {
  ProgramState: ProgramState;
  ProgramDispatch(action: ProgramActions): void;
};

export const ProgramContext = React.createContext<ContextState>({
  ProgramState: InitialProgramState,
  ProgramDispatch() {
    console.warn("Context.Provider外からの呼び出し");
  },
});
